export default __webpack_public_path__ + "4f963bb6433db0a043535065d9fc6bab.jpg";